import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Tea as TeaSDK, gameUtils } from '@fe/game-sdk';
import AppContainer from './Container';
import Loading from '~/components/Loading';
import { PrefetchData, prefetchData } from '~/common/services';
import { descWithI18n, titleWithI18n } from '~/common/consts';
import pageConfig from '~/config';

const start = Date.now();
export default function App(props: any) {
  const { data } = props._ssrData;

  const { language, imageUrl, shareImageUrl, isInit } = (data?.prefetchData as PrefetchData) || {};
  console.info('album', language, imageUrl);

  const renderTDK = () => {
    return {
      title: titleWithI18n[language] || titleWithI18n.en,
      description: descWithI18n[language] || descWithI18n.en
    };
  };

  useEffect(() => {
    if (!isInit) {
      return;
    }
    if (!imageUrl) {
      const sandboxStr = ['bytedance.net', 'sandbox', 'localhost'];
      const isSandbox =
        typeof window !== 'undefined' && sandboxStr.some((str) => location.origin.includes(str));
      const query = gameUtils.parseQuery();
      if (query?.test === '1') {
        return;
      }
      if (isSandbox) {
        location.href = `https://act-sandbox.vasnssdk.com/gms/b1e398fc30`;
      } else {
        // TODO 需要改成分享中转页(当前)页面域名
        location.href = `https://www.marvelsnap.com/seasonrecap/s20/share`;
      }
      return;
    }
    location.href = imageUrl;
  }, [imageUrl, isInit, shareImageUrl]);
  useEffect(() => {
    TeaSDK.initSendLogV3({
      app_id: pageConfig.appId,
      activity_id: pageConfig.actId,
      zone: pageConfig.region,
      // 非必传参数，这个字段可以自定义通用参数，并且会在所有埋点事件里统一传参
      default_data: {
        page_text: pageConfig.title,
        activity_form: '1'
      }
    });

    TeaSDK.sendLogV3('acv_pageview', {
      index: 1
    });
    TeaSDK.sendLogV3('acv_pageload', {
      index: 1,
      duration: Date.now() - start
    });
  }, []);
  return (
    <>
      <Helmet>
        <meta property="og:title" content={renderTDK().title} />
        <meta property="og:description" content={renderTDK().description} />
        <meta property="og:image" content={shareImageUrl} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta name="twitter:title" content={renderTDK().title} />
        <meta name="twitter:description" content={renderTDK().description} />
        <meta name="twitter:image" content={shareImageUrl} />
        <title>{renderTDK().title}</title>
      </Helmet>
      <AppContainer {...props} />
    </>
  );
}

// 支持 react-helmet
App.disableStream = true;

App.init = (context) => {
  const { level } = context.request.query;
  if (['0', '1', '2'].includes(level)) {
    // 2 表示服务器渲染，1表示服务端预取数据，0表示客户端渲染
    context.targetRenderLevel = Number(level);
  }
  // 2 表示服务器渲染，1表示服务端预取数据，0表示客户端渲染
};

App.prefetch = prefetchData;

App.config = {
  features: {
    ssr: {
      customPrefetch: {
        LoadingComponent: Loading
      }
    }
  }
};
